export default {
  frontRoutes: [
    // {
    //   path: "/index/rec-goods",
    //   name: "IndexRecommendGoods",
    //   component: () =>
    //     import(/* webpackChunkName: "book" */ "../views/goods/Goods.vue"),
    // },
    {
      path: '/ebook',
      name: 'Ebooks',
      component: () => import(/* webpackChunkName: "book" */ '../views/ebooks/Ebooks.vue'),
    },
    {
      path: '/ebooks/:id',
      name: 'EbooksDetail',
      component: () => import(/* webpackChunkName: "book" */ '../views/ebooks/EbooksDetail.vue'),
    },
  ],
  memberRoutes: [],
};
